export const repos = [
  {
    title: 'Portfolio',
    description:
      'My personal portfolio to show my skills, experience, and articles I published.',
    languages: 'Nextjs, chakraUi',
    url: 'https://github.com/MA-Ahmad/myPortfolio',
    live: 'https://mahmad.me',
    stars: '136',
    fork: '32',
  },
  {
    title: 'Portfolio2',
    description:
      'This portfolio built by using Next.js, ChakraUi and Typescript.',
    languages: 'Typescript, React, ChakraUi',
    url: 'https://github.com/MA-Ahmad/portfolio',
    live: 'https://ma-ahmad.github.io/portfolio',
    stars: '81',
    fork: '14',
  },
  {
    title: 'Notebook',
    description: 'Make notes for your daily work.',
    languages: 'Typescript, React, ChakraUi',
    url: 'https://github.com/MA-Ahmad/notebook',
    live: 'https://ma-ahmad.github.io/notebook',
    stars: '22',
    fork: '8',
  },
  {
    title: 'Blog App(React)',
    description:
      'A React Blog App built by using libraries like ChakraUI, Formik.',
    languages: 'Javascript, React, ChakraUi, Formik',
    url: 'https://github.com/MA-Ahmad/reactBlog',
    live: 'https://ma-ahmad.github.io/reactBlog',
    stars: '18',
    fork: '2',
  },
  {
    title: 'Blog App (Front-end)',
    description: 'React frontend of a blog app with rails on backend.',
    languages: 'Javascript, React, ChakraUi',
    url: 'https://github.com/MA-Ahmad/blog-app-react-frontend',
    live: 'https://blog-frontend-react.herokuapp.com',
    stars: '17',
    fork: '5',
  },
  {
    title: 'Blog App',
    description: 'A simple react+rails(RR) CRUD app with tailwindcss.',
    languages: 'Ruby, Rails, Javascript, React, TailwindCss',
    url: 'https://github.com/MA-Ahmad/react_rails_blog',
    live: 'https://react-on-rails-blog.herokuapp.com',
    stars: '8',
  },
  {
    title: 'Blog App (Back-end)',
    description: 'Rails backend api for blog app with react on frontend.',
    languages: 'Ruby, Rails',
    url: 'https://github.com/MA-Ahmad/blog-app-rails-backend',
    stars: '6',
    fork: '1',
  },
  {
    title: 'Video-to-text',
    description: 'Convert a video to text using ruby.',
    languages: 'Ruby',
    url: 'https://github.com/MA-Ahmad/Video-to-text',
    stars: '5',
  },

  {
    title: 'Authentication API',
    description:
      'Simple Authentication API that can be used with any front-end app like React, Vue, Angular app.',
    languages: 'Ruby, Rails',
    url: 'https://github.com/MA-Ahmad/rails-authentication-app',
    stars: '3',
  },
];
